"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var __1 = require("../..");
var contexts_1 = require("../../contexts");
var notification_1 = __importDefault(require("../../helpers/notification"));
var hooks_1 = require("../../hooks");
var ButtonCancel_1 = __importDefault(require("../ButtonCancel"));
var ButtonNew_1 = __importDefault(require("../ButtonNew"));
var CompositeView_1 = __importDefault(require("../CompositeView"));
var CrudCreate_1 = __importDefault(require("./CrudCreate"));
var CrudEdit_1 = __importDefault(require("./CrudEdit"));
var CrudList_1 = __importDefault(require("./CrudList"));
var CrudSimpleView = function (props) {
    var getAllItems = props.getAllItems, createItem = props.createItem, updateItem = props.updateItem, deleteItem = props.deleteItem, table = props.table, children = props.children, filter = props.filter, title = props.title, getItem = props.getItem, _a = props.permissions, permissions = _a === void 0 ? {} : _a;
    var _b = react_1.useState(filter && filter.initialValues), filterValues = _b[0], setFilterValues = _b[1];
    var _c = react_1.useState(), selectedItem = _c[0], setSelectedItem = _c[1];
    var _d = react_1.useState([]), items = _d[0], setItems = _d[1];
    var _e = hooks_1.useRouter(), pushRoot = _e.pushRoot, rootUrl = _e.rootUrl;
    var handleFilter = function (value) {
        setFilterValues(value);
        handleGetAll(value);
    };
    var handleCreate = function (value) { return __awaiter(_this, void 0, void 0, function () {
        var resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, createItem(value)];
                case 1:
                    resp = _a.sent();
                    if (resp) {
                        notification_1.default.success('ui.message.api.save.success');
                    }
                    pushRoot();
                    handleGetAll(filterValues);
                    return [2, resp];
            }
        });
    }); };
    var handleUpdate = function (value) { return __awaiter(_this, void 0, void 0, function () {
        var resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, updateItem(value)];
                case 1:
                    resp = _a.sent();
                    if (resp) {
                        notification_1.default.success('ui.message.api.save.success');
                    }
                    pushRoot();
                    handleGetAll(filterValues);
                    return [2, resp];
            }
        });
    }); };
    var handleDelete = function (value) { return __awaiter(_this, void 0, void 0, function () {
        var resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, deleteItem(value)];
                case 1:
                    resp = _a.sent();
                    if (resp) {
                        notification_1.default.success('ui.message.api.delete.success');
                    }
                    pushRoot();
                    handleGetAll(filterValues);
                    return [2, resp];
            }
        });
    }); };
    var handleGetAll = react_1.useCallback(function (value) { return __awaiter(_this, void 0, void 0, function () {
        var resp, resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!value) return [3, 2];
                    return [4, getAllItems(value)];
                case 1:
                    resp = _a.sent();
                    if (resp)
                        setItems(resp);
                    _a.label = 2;
                case 2:
                    if (!(!filter || !filter.form)) return [3, 4];
                    return [4, getAllItems()];
                case 3:
                    resp = _a.sent();
                    if (resp)
                        setItems(resp);
                    _a.label = 4;
                case 4: return [2];
            }
        });
    }); }, [getAllItems, filter]);
    react_1.useEffect(function () {
        handleGetAll();
    }, [handleGetAll]);
    var crudContextValue = react_1.useMemo(function () { return ({
        selectedItem: selectedItem,
        isCreate: !selectedItem,
        isUpdate: !!selectedItem,
    }); }, [selectedItem]);
    return (react_1.default.createElement(contexts_1.CrudContext.Provider, { value: crudContextValue },
        react_1.default.createElement(__1.SimpleView, { viewPermission: permissions.read },
            react_1.default.createElement(CompositeView_1.default, { toolbar: react_1.default.createElement(ButtonNew_1.default, { linkTo: rootUrl('new'), viewPermission: permissions.create }) },
                react_1.default.createElement(CrudList_1.default, { title: title, table: __assign({}, table, { dataSource: items }), filter: __assign({}, filter, { initialValues: filterValues }), onFilter: handleFilter, onDelete: handleDelete, selectItem: setSelectedItem, updatePermissions: permissions.update, deletePermissions: permissions.delete, createPermissions: permissions.create })),
            react_1.default.createElement(CompositeView_1.default, { id: "new", viewPermission: permissions.create, toolbar: react_1.default.createElement(ButtonCancel_1.default, { linkTo: rootUrl() }) },
                react_1.default.createElement(CrudCreate_1.default, { parentUrl: rootUrl(), onCreate: handleCreate }, children)),
            react_1.default.createElement(CompositeView_1.default, { id: "edit", path: "/:id", viewPermission: permissions.update, toolbar: react_1.default.createElement(ButtonCancel_1.default, { linkTo: rootUrl() }) },
                react_1.default.createElement(CrudEdit_1.default, { parentUrl: rootUrl(), selectedItem: selectedItem, getItem: getItem, onUpdate: handleUpdate }, children)))));
};
exports.default = CrudSimpleView;
